import React, { FC } from 'react';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { Energikarakter } from '../../../../components/energimerke/energikarakter';
import { SimpleEnergyPlan } from '../../../../types/building';
import { fromEnergiplanToEnergimerke } from '../../../../components/energimerke/utils';
import useFormatDate from '../../../../hooks/useFormatDate';
import { CardHeaderWrapper, TilstandCard } from '../styledComponents';
import { SuccessTag, WarningTag } from '../../../../components/tag';

import { TilstandMenu } from './tilstandMenu';
import { CardContentColumn, CardContentRow } from './styledComponents';

interface Props {
  title: string;
  energiplan: SimpleEnergyPlan;
}

export const Tilstand: FC<Props> = ({ energiplan, title }) => {
  const energimerke = fromEnergiplanToEnergimerke(energiplan);
  const { formatDate } = useFormatDate();
  const { t } = useTranslation('', { keyPrefix: 'screens.energiplan.components.tilstand' });

  const finished = !!energiplan.publisertDato;

  return (
    <TilstandCard>
      <CardHeaderWrapper>
        {finished ? <SuccessTag label={t('statusDone')} /> : <WarningTag label={t('statusInProgress')} />}
        <CardContentRow>
          <Energikarakter energimerke={energimerke} />
          <CardContentColumn>
            <Heading data-size="sm">{title}</Heading>
            <Paragraph data-size="xs">{t('lastUpdated', { date: formatDate(energiplan.endretDato) })}</Paragraph>
          </CardContentColumn>
        </CardContentRow>
      </CardHeaderWrapper>

      <TilstandMenu energiplan={energiplan} />
    </TilstandCard>
  );
};
